export default "__VITE_ASSET__Cm6jsW3x__"